export default __webpack_public_path__ + "static/media/shangbiao2.c26709b6.png";